<template>
	<div>
		<p class="h4 text-center mt-4">
			{{$t('account/bookings.Booking achieved')}}
		</p>

		<p class="mt-2 d-flex align-items-center justify-content-center">
			{{$t('account/bookings.Booking reference is')}} : 
			<strong class="h5 ml-2 mb-0">
				{{referred.reference}}
			</strong>
		</p>

		<div class="text-center my-4">
			<a 
			:href="referred.url" 
			class="btn btn-lg btn-primary">
				{{$t('account/bookings.View my folder')}}
			</a>
		</div>
	</div>
</template>

<script>

	import {mapState} from 'vuex'

	export default {

		computed: {

			...mapState({
				output: state => state.booking.output,
			}),

			referred() {

				if(_.size(this.output))
				{
					return this.output.folder || this.output.missions[0]
				}

				return {}
			}

		}


	}
</script>